import * as React from "react";

import styled from "styled-components";
import { getGroups } from "../api/api";
import { Breadcrumb } from "antd";
import GroupItem from "../comp/groupitem";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .rightcontent {
    flex: 1;
    .list {
      display: flex;
      flex-wrap: wrap;
    }
  }
`;

const List: React.FunctionComponent = () => {
  const [alist, setalist] = React.useState<Array<any>>([]);
  const navigate = useNavigate();

  const agetList = async () => {
    const ret = await getGroups({
      pageNum: 1000,
      pageSize: 10,
    });
    setalist(ret?.myGroups ?? []);
  };

  React.useEffect(() => {
    agetList();
  }, []);

  return (
    <Container>
      <div className="rightcontent">
        <div className="breadCrmb">
          <Breadcrumb>
            <Breadcrumb.Item>
              <span className="p" onClick={() => navigate("/group")}>
                首页
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>我的小组</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="list">
          {(alist ?? []).map((x: any) => (
            <GroupItem item={x} key={`${x.id}+${Math.random}`} />
          ))}
          {(alist ?? []).length === 0 && (
            <div className="jsc fs16 mt50">暂无数据</div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default List;
